import React from 'react';
import {connect} from 'react-redux'
import { Modal, Row} from "antd";
import 'antd/lib/modal/style/css';
import getCRLReasons from "../../actions/getCRLReasons";
import {Button} from "antd";
import { Select } from 'antd';

const { Option } = Select;

class CRLReasonsModal extends React.Component {

    componentDidMount()
    {
        this.props.getCRLReasons();
    }

    renderOptions=()=>
    {
        if(!this.props.crlReasons || this.props.crlReasons.length<=0)
            return '';
        return this.props.crlReasons.map(d => <Option key={d.code}>{d.name}</Option>);
    };
    state={selectedReason:0};
    render() {
        return (
            <Modal centered visible={this.props.modalType !== null} {...this.props.modalProps}>
                <Row className={'text-center block'}>
                    <strong>{this.props.message} </strong>
                </Row>
                <br />
                <Row className={'text-center block'}>
                    <Select defaultValue="0" style={{ width: 300 }} onChange={(value) => this.setState({selectedReason:value})}>
                        {this.renderOptions()}
                    </Select>
                </Row>
                <br />
                <Row className={'text-center block'}>
                    <Button onClick={()=>{this.props.onOK(this.state.selectedReason)}} type={'primary'}>{this.props.btnOK}</Button>
                    <Button onClick={this.props.onCancel} type={'primary'}>{this.props.btnCancel}</Button>
                </Row>
            </Modal>
        )
    }

}

function mapStateToProps(state) {
    return {
        language: state.auth.language,
        crlReasons:state.certificates.crlReasons
    }
}

export default connect(mapStateToProps, {getCRLReasons})(CRLReasonsModal);
